import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { StickerPackInterface, setEditId, setEditError, selectStickerPackById } from "../../../store/sticker_maker/stickerPacksSlice";
import { updateStickerPack, fetchStickerPack } from "../../../actions/sticker_maker/stickerPacksActions";
import { fetchCategories } from "../../../actions/sticker_maker/categoriesActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch    = useAppDispatch();
  const location    = useLocation();
  const id: any     = useAppSelector(state => state.stickerMaker.stickerPacks.editId);
  const error       = useAppSelector(state => state.stickerMaker.stickerPacks.editError);
  const stickerPack = useAppSelector(state => id ? selectStickerPackById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target: 1 }));
      dispatch(fetchStickerPack(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: StickerPackInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: StickerPackInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateStickerPack({ id, data: formData }));

    if (updateStickerPack.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-stickerPack'>
        <h6 className="v-content-label">Edit StickerPack</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={stickerPack} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
